<template>

  <div id="page-user-list">
    <div class="vx-card p-6">

      <div class="flex flex-wrap items-center">

        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div class="pagidropdown border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ categoriesData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : categoriesData.length }} of {{ categoriesData.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>

              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
          
          <vs-input class="teacherSearchBtn sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="searchQuery" @input="updateSearchQuery" placeholder="Search..." />
          
          <vs-button @click="addCategory" class="mt-4 mr-2 shadow-lg" type="gradient" color="primary"  icon-pack="feather" icon="icon-menu" icon-after>Add Category</vs-button>
          
          

      </div>


      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="categoriesData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="false"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl">
      </ag-grid-vue>

      <vs-pagination
        :total="totalPages"
        :max="7"
        v-model="currentPage" />

    </div>
  </div>

</template>

<script>
import { AgGridVue } from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'
import axios from "@/axios.js"

// Store Module
import moduleLearningHub from '@/store/learninghub/moduleLearningHub.js'

import CellRendererLink from "./cell-renderer/CellRendererLink.vue"

export default {
  components: {
    AgGridVue,
    vSelect,
    CellRendererLink
  },
  data() {
    return {
      
      // Filter Options
      roleFilter: { label: 'All', value: 'all' },
      searchQueryDateFrom: '',
      searchQueryDateTo: '', 
      statusFilter: { label: 'Status - All', value: 'all' },
      isVerifiedFilter: { label: 'Email - All', value: 'all' },
      departmentFilter: { label: 'All', value: 'all' },
      searchQuery: "",
     

      // AgGrid
      gridApi: null,
      gridOptions: {
        onRowDragEnd: this.onRowDragEnd,  // Highlighted: Handling row drag end
      },
      defaultColDef: {
        filterable: false,
        sortable: true,
        resizable: true,
        suppressMenu: true
      },
      columnDefs: [
        {
          headerName: 'Sort',
          field: 'sort',
          width: 80,
          filter: false,
          checkboxSelection: false,
          headerCheckboxSelectionFilteredOnly: false,
          headerCheckboxSelection: false,
          rowDrag: true,  // Highlighted: Enable row dragging
        },
        {
          headerName: 'ID',
          field: 'id',
          width: 80,
          filter: false,
          checkboxSelection: false,
          headerCheckboxSelectionFilteredOnly: false,
          headerCheckboxSelection: false,
          // rowDrag: true,  // Highlighted: Enable row dragging
        },
        {
          headerName: 'Name English',
          field: 'name_en',
          filter: false,
          width: 300,
        },
        {
          headerName: 'Name Danish',
          field: 'name_da',
          filter: false,
          width: 300,
        },
        {
          headerName: 'Actions',
          field: 'id',
          filter: false,
          width: 115,
          cellRendererFramework: 'CellRendererLink'
        },
      ],

      components: {
        CellRendererLink
      }

    }
  },
  watch: {
  },
  computed: {
    categoriesData() {
      return this.$store.state.learninghubManagement.categories
    },
    paginationPageSize() {
      if(this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 10
    },
    totalPages() {
      if(this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get() {
        if(this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1)
      }
    }
  },
  methods: {
    // Highlighted: Handle row dragging and swapping
    onRowDragEnd(event) {
      const movedItem = event.node.data;
      const overIndex = event.overIndex;

      // Remove the dragged item from its original position
      const oldIndex = this.categoriesData.findIndex(item => item.id === movedItem.id);
      this.categoriesData.splice(oldIndex, 1);

      // Insert the dragged item at its new position
      this.categoriesData.splice(overIndex, 0, movedItem);
      
      // Define a new array to store the IDs
      const idsArray = this.categoriesData.map(item => item.id);

      // Convert the array to a comma-separated string
      const orderString = idsArray.join(',');

      // Log the new order string
      console.log('Updated Order:', orderString);

       // Send the updated order to the server
        this.updateOrder(orderString);

      // Refresh the grid data
      this.gridApi.setRowData(this.categoriesData);
      console.log('update',this.categoriesData);
    },
    updateOrder(orderString) {
      const token = localStorage.getItem("accessToken");

      axios.post('https://backend.heyway.com/api/learninghub/categories/updateorder', 
        { ids: orderString }, // Send data as JSON
        { headers: { 
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json' // Set Content-Type header
        }}
      )
      .then(response => {
        console.log('Order updated successfully:', response.data);
      })
      .catch(error => {
        console.error('Error updating order:', error);
      });
    },
 
    setColumnFilter(column, val) {
      const filter = this.gridApi.getFilterInstance(column)
      let modelObj = null

      if(val !== "all") {
        modelObj = { type: "equals", filter: val }
      }

      filter.setModel(modelObj)
      this.gridApi.onFilterChanged()
    },
    resetColFilters() {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()

      // Reset Filter Options
      this.roleFilter = this.statusFilter = this.isVerifiedFilter = this.departmentFilter = { label: 'All', value: 'all' }
      this.searchQueryDateFrom = ''
      this.searchQueryDateTo = ''

      this.$refs.filterCard.removeRefreshAnimation()
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val)
    },
    addCategory() {
            this.$router.push("/learninghubcategories/add").catch(() => {})
        },
  },
  mounted() {
    
    this.gridApi = this.gridOptions.api
    

    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if(this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(".ag-header-container")
      header.style.left = "-" + String(Number(header.style.transform.slice(11,-3)) + 9) + "px"
    }
  },
  created() {
    if(!moduleLearningHub.isRegistered) {
        console.log('is registered not');
      this.$store.registerModule('learninghubManagement', moduleLearningHub)
      moduleLearningHub.isRegistered = true
    }
    this.$store.dispatch("learninghubManagement/fetchCategories").catch(err => { console.log(err) })
  }
}

</script>



<style type="text/css">

.pagidropdown{
    padding: 11px!important;
}

.rounded-full {
    border-radius: 7px !important;
}

.teacherSearchBtn{
  width: 34% ! important;
}

.teacherSearchStatus{
  width: 17% ! important;
}

.teacherSearchEmail{
  width: 17% ! important;
}
</style>